import React, { useEffect, useState } from 'react';
import { contactRecordIsPatient, PAYOR_TYPES } from '../../../lib/helper/invoice';
import ContactRecordDrawer from './ContactRecordDrawer';
import HospitalContactRecordDrawer from '../../HospitalSingle/components/HospitalContactRecordDrawer';
import type { ContactRecord } from '../../../apiTypes';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { contactRecordTypeListFetch } from '../../../lib/redux/actions/contactRecordType';

interface Props {
  setContactsUnderEdit: (contactsUnderEdit: boolean) => void;
  contacts: ContactRecord[];
  addNewContact: (newContact: ContactRecord) => boolean;
  removeContact: (contactToRemove: ContactRecord) => boolean;
  updateContact: (updatedContact: ContactRecord, origContact: ContactRecord) => boolean;
  existingInvoice?: boolean;
  payorTypeCode?: number;
  hospital?: any;
  contactRecordTypeListFetch?: any;
}

const mapDispatchToProps = {
  contactRecordTypeListFetch,
};

const ManageInvoiceContactsComponent = ({
  contacts = [],
  updateContact,
  addNewContact,
  removeContact,
  setContactsUnderEdit,
  existingInvoice = false,
  payorTypeCode = PAYOR_TYPES.PATIENT,
  hospital,
  contactRecordTypeListFetch,
}: Props) => {
  const [addingContact, setAddingContact] = useState(false);
  const [formsUnderEdit, setFormsUnderEdit] = useState<string[]>([]);

  const toggleFormUnderEdit = (formId: string) => {
    setFormsUnderEdit(formsUnderEdit.includes(formId) ? [...formsUnderEdit.filter((f) => f !== formId)] : [...formsUnderEdit, formId]);
  };

  useEffect(() => {
    setContactsUnderEdit(!Boolean(formsUnderEdit.length));
  }, [formsUnderEdit, setContactsUnderEdit]);

  const hasPatientContact = contacts.some((c) => contactRecordIsPatient(c));
  const isHospitalType = payorTypeCode === PAYOR_TYPES.HOSPITAL;

  return (
    <Row>
      <Col>
        {contacts.map((contact) =>
          isHospitalType ? (
            <HospitalContactRecordDrawer
              key={contact.name + (contact.id ?? '-1')}
              hospital={hospital}
              isNew={contact.id === -1}
              canRemove={contacts.length > 1}
              toggleFormUnderEdit={toggleFormUnderEdit}
              contact={contact}
              onSubmit={(c: ContactRecord) => updateContact(c, contact)}
              startOpen={contact.id === -1 || contactRecordIsPatient(contact)}
              onRemove={(c: ContactRecord) => removeContact(c)}
              contactRecordTypeListFetch={contactRecordTypeListFetch}
            />
          ) : (
            <ContactRecordDrawer
              key={contact.name + (contact.id ?? '-1')}
              isNew={contact.id === -1}
              existingInvoice={existingInvoice}
              canRemove={contacts.length > 1}
              toggleFormUnderEdit={toggleFormUnderEdit}
              showPatientOption={!hasPatientContact || contactRecordIsPatient(contact)}
              contact={contact}
              onSubmit={(c: ContactRecord) => updateContact(c, contact)}
              startOpen={contact.id === -1 || contactRecordIsPatient(contact)}
              onRemove={(c: ContactRecord) => removeContact(c)}
            />
          ),
        )}
        {!addingContact ? (
          <button className={'btn btn-outline-secondary'} type={'button'} onClick={() => setAddingContact(true)}>
            Add another contact
          </button>
        ) : (
          <>
            {isHospitalType ? (
              <HospitalContactRecordDrawer
                hospital={hospital}
                canRemove={false}
                toggleFormUnderEdit={toggleFormUnderEdit}
                isNew={true}
                contact={
                  {
                    notifyByMobile: true,
                    notifyByEmail: true,
                  } as ContactRecord
                }
                startOpen={true}
                onSubmit={(c: ContactRecord) => {
                  const added = addNewContact(c);
                  setAddingContact(false);
                  return added;
                }}
                onRemove={() => {}}
                contactRecordTypeListFetch={contactRecordTypeListFetch}
              />
            ) : (
              <ContactRecordDrawer
                existingInvoice={existingInvoice}
                canRemove={false}
                toggleFormUnderEdit={toggleFormUnderEdit}
                isNew={true}
                showPatientOption={!hasPatientContact}
                contact={
                  {
                    notifyByMobile: true,
                    notifyByEmail: true,
                  } as ContactRecord
                }
                startOpen={true}
                onSubmit={(c: ContactRecord) => {
                  const added = addNewContact(c);
                  setAddingContact(false);
                  return added;
                }}
              />
            )}

            <button className={'btn btn-danger float-right'} type={'button'} onClick={() => setAddingContact(false)}>
              Cancel adding contact
            </button>
          </>
        )}
      </Col>
    </Row>
  );
};

export const ManageInvoiceContacts = connect(null, mapDispatchToProps)(ManageInvoiceContactsComponent);
